import $ from 'jquery';

$('.inline-nav').each(function () {
    const $self = $(this);
    const $menu = $self.find('.inline-nav__menu');
    const $forward = $self.find('.scroll-nav--forward');
    const $back = $self.find('.scroll-nav--back');

    $self.find('a').click(function () {
        $self.find('a').removeClass('active');
        $(this).addClass('active');
    });

    $forward.click(() => {
        console.log($menu[0].scrollLeft);
        $menu[0].scrollTo($menu[0].scrollLeft + 200, 0);
    });

    $back.click(() => {
        $menu[0].scrollTo($menu[0].scrollLeft - 200, 0);
    });
});

